import {Injectable} from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogState} from '@angular/material/dialog';
import {AlertMiniAmountComponent} from 'src/app/components/dialogs/alert-mini-amount/alert-mini-amount.component';
import {AlertMaxWeightComponent} from 'src/app/components/dialogs/alert-max-weight/alert-max-weight.component';
import {WeightsTableComponent} from 'src/app/components/dialogs/weights-table/weights-table.component';
import {AlertInvalidCountryComponent} from 'src/app/components/dialogs/alert-invalid-country/alert-invalid-country.component';
import {MediaObserver} from '@angular/flex-layout';
import {EligibleCitiesComponent} from 'src/app/components/dialogs/eligible-cities/eligible-cities.component';
import {AlertInvalidCityComponent} from 'src/app/components/dialogs/alert-invalid-city/alert-invalid-city.component';
import {AlertInvalidSlotComponent} from 'src/app/components/dialogs/alert-invalid-slot/alert-invalid-slot.component';
// import {TermsConditionsComponent} from 'src/app/components/dialogs/terms-conditions/terms-conditions.component';
import {AlertRecoveryOrderChangesComponent} from 'src/app/components/dialogs/alert-recovery-order-changes/alert-recovery-order-changes.component';
import {FulleShedulesComponent} from 'src/app/components/dialogs/fulle/fulle-shedules/fulle-shedules.component';
import {AlertInvalidRubricSlotComponent} from 'src/app/components/dialogs/alert-invalid-rubric-slot/alert-invalid-rubric-slot.component';
import {AlertInvalidPricePeriodComponent} from 'src/app/components/dialogs/alert-invalid-price-period/alert-invalid-price-period.component';
import {DescriptionOrderComponent} from 'src/app/components/dialogs/description-order/description-order.component';
import {BarcodeComponent} from 'src/app/components/dialogs/booking/barcode/barcode.component';
import {AlertStockComponent} from 'src/app/components/dialogs/alert-stock/alert-stock.component';
import {AlertAlcoolComponent} from 'src/app/components/dialogs/alert-alcool/alert-alcool.component';
import {AlertArchiveSaleMethodComponent} from 'src/app/components/dialogs/alert-archive-sale-method/alert-archive-sale-method.component';
import {ToolsService} from '../../tools/tools.service';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class DialogsService {
  myDialAlertStockDial: any;
  myDialAlertSMDial: any;

  constructor(
    private dialog: MatDialog,
    private tools: ToolsService,
    private media: MediaObserver,
    //private productService: ProductService
  ) {
  }

  // Mini amount dialog
  openMiniAmountDial() {
    let myConf = new MatDialogConfig();
    myConf.disableClose = true;
    this.dialog.open(AlertMiniAmountComponent, myConf);
  }

  // Maximum order weight exceeded dialog
  openMaxWeightDial(delivryAddress: any, isRelay?: boolean, relay?: any) {
    let myConf = new MatDialogConfig();
    myConf.data = {delivryAddress: delivryAddress, isRelay: isRelay, relay: relay}
    this.dialog.open(AlertMaxWeightComponent, myConf);
  }

  // Invalid country dialog
  openInvalidCountryDial(delivryAddress: any) {
    let myConf = new MatDialogConfig();
    myConf.data = {delivryAddress: delivryAddress}
    this.dialog.open(AlertInvalidCountryComponent, myConf);
  }

  // Invalid city dialog
  openInvalidCityDial(delivryAddress: any) {
    let myConf = new MatDialogConfig();
    myConf.data = {delivryAddress: delivryAddress}
    this.dialog.open(AlertInvalidCityComponent, myConf);
  }

  // Weight list dialog
  openWeightTableDial(delivryAddress: any, isRelay?: boolean, relay?: any) {
    let myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.data = {delivryAddress: delivryAddress, isRelay: isRelay, relay: relay};
    this.media.isActive("xs") ? myConf.width = "100%" : myConf.minWidth = "350px";
    this.dialog.open(WeightsTableComponent, myConf);
  }

  // Eligible cities
  openEligibleCitiesDial() {
    let myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    this.media.isActive("xs") ? myConf.width = "100%" : myConf.minWidth = "400px";
    this.dialog.open(EligibleCitiesComponent, myConf);
  }

  // Invalid slot
  openInvalidSlotDial() {
    let myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    this.dialog.open(AlertInvalidSlotComponent, myConf);
  }

  // Termes and conditions
  // openTermsConditionsDial() {
  //   let myConf = new MatDialogConfig();
  //   myConf.autoFocus = false;
  //   myConf.panelClass = "full-screen";
  //   this.dialog.open(TermsConditionsComponent, myConf);
  // }

  // Recovery order cahnges
  openRecoveryOrderChangesDial(recoveryChanges: any[], categories: any[]) {
    let myConf = new MatDialogConfig();
    myConf.data = {changes: recoveryChanges, categories: categories};
    myConf.autoFocus = false;
    this.media.isActive("xs") ? myConf.width = "100%" : myConf.minWidth = "400px";
    this.dialog.open(AlertRecoveryOrderChangesComponent, myConf);
  }

  // Point of sale Shedules
  openShedulesDial(point: any, sm: any) {
    let myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.data = {
      point_of_sale: point,
      sale_method: sm
    };
    this.media.isActive("xs") ? myConf.width = "100%" : myConf.minWidth = "400px";
    this.dialog.open(FulleShedulesComponent, myConf);
  }

  // Maximum rub reaches error
  openAlertRubSlotDial(errRub: any) {
    let myConf = new MatDialogConfig();
    myConf.data = {errRub: errRub}
    this.media.isActive("xs") ? myConf.width = "100%" : myConf.width = "400px";
    this.dialog.open(AlertInvalidRubricSlotComponent, myConf);
  }

  // Maximum rub reaches error
  openAlertPricePeriodDial(errPeriod: any) {

    let myConf = new MatDialogConfig();
    myConf.data = {errPeriod: errPeriod}
    this.media.isActive("xs") ? myConf.width = "100%" : myConf.width = "500px";
    this.dialog.open(AlertInvalidPricePeriodComponent, myConf);
  }

  // Promo's shedules
  openPromoShedulesDial(idPricePeriod: any) {

    //TODO remettre une fois l'architecture en place
    /*let pricePeriod = this.productService.searchPricePeriodById(idPricePeriod)
    if(pricePeriod != null){
      let myConf = new MatDialogConfig();
      myConf.data = { pricePeriod: pricePeriod }
      this.media.isActive("xs") ? myConf.width = "100%" : myConf.minWidth = "400px";
      this.dialog.open(PromoShedulesComponent, myConf);
    }*/
  }

  //Description order
  openDescriptionOrderDial() {
    let myConf = new MatDialogConfig();
    this.media.isActive("xs") ? myConf.width = "100%" : myConf.width = "600px";

    const myDial = this.dialog.open(DescriptionOrderComponent, myConf);
  }

  //open barcode ref booking
  openRefBookingDial(booking: any) {
    let myConf = new MatDialogConfig();
    myConf.data = {reference: booking.reference, reference_base64: booking.reference_base64};
    this.media.isActive("xs") ? myConf.width = "100%" : myConf.width = "400px";
    const myDial = this.dialog.open(BarcodeComponent, myConf);
  }

  /**
   * Affichage des alertes stocks
   * @param negativeStock Tableau des alertes stocks
   */
  openAlertStockDial(negativeStock: any) {
    if (this.myDialAlertStockDial && this.myDialAlertStockDial.getState() === MatDialogState.OPEN) {
      // La dialogue est déja ouverte
    }
    // Affichage des alertes stocks
    else {
      let myConf = new MatDialogConfig();
      myConf.data = negativeStock;
      this.media.isActive("xs") ? myConf.width = "100%" : myConf.width = "400px";
      this.myDialAlertStockDial = this.dialog.open(AlertStockComponent, myConf);
    }
  }

  /**
   * @description Open alert alcool dialog
   */
  openAlertAlcoolDial(dialogRef: any, pointOfSale: any) {
    let myConf = new MatDialogConfig();
    myConf.data = {pointOfSale: pointOfSale};
    myConf.panelClass = ['full-height-dialog'];
    myConf.disableClose = true;
    const myDial = this.dialog.open(AlertAlcoolComponent, myConf);
    myDial.afterClosed().subscribe(data => {
      // Le client a validé le message
      if (data) {
        this.tools.setStor("alcool_check", true);
      }
      // Sinon retour
      else {
        this.tools.goPointOfSalePage();
        dialogRef.close();
      }
    })
  }

  /**
   * @description Open alert sale_method dialog
   * @param {any} sale_method
   */
  // Invalid sale_method (archive>0)
  openInvalidSalemethodDial(sale_method: any, currPos: any) {

    if (this.myDialAlertSMDial && this.myDialAlertSMDial.getState() === MatDialogState.OPEN) {

      // The dialog is opened.
    } else {
      let myConf = new MatDialogConfig();
      myConf.data = {saleMethod: sale_method};
      this.media.isActive("xs") ? myConf.width = "100%" : myConf.width = "400px";
      this.myDialAlertSMDial = this.dialog.open(AlertArchiveSaleMethodComponent, myConf);
    }
  }
}
